import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`

    

    body {
        margin: 0;
        font-family: system-ui;
        background: #161a1e;
        display: flex;
        color: #e7e7e7;
        overflow: auto;
    }

`

export default GlobalStyle